<script>
import {defineComponent} from 'vue'

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Login',
  data() {
    return {
      login: null,
      password: null
    }
  },
  methods: {
    submit() {
      this.$auth.attempt(this.login, this.password);
    }
  }
})
</script>

<template>
  <div class="d-flex" style="height: 100%; width: 100%">
    <div class="mx-auto p-4" style="width: 100%; max-width: 450px; margin-top: 20vh">
      <form @submit.prevent="submit">
        <div class="form-group">
          <label class="text-left">Tên đăng nhập</label>
          <input type="text" class="form-control" v-model="login" required>
        </div>
        <div class="form-group">
          <label class="text-left">Mật khẩu </label>
          <input type="password" class="form-control" v-model="password" required>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-primary w-100">Đăng nhập</button>
        </div>
      </form>
    </div>

  </div>
</template>

<style scoped>

</style>
